import React from "react";

const ProgressBar = props => {
  const { completed } = props;

  const fillerStyles = {
    width: `${completed}%`,
  };

  return (
    <div className={"progress-bar__bar"}>
      <div className={"progress-bar__fill"} style={fillerStyles}></div>
    </div>
  );
};

export default ProgressBar;
